import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import {greys, perkbox} from "@irati/ui/src/global/colors"

const Circle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${({isActive}) => (isActive ? perkbox.blue : greys.light)};
  padding: 0;
  margin: 0;
  outline: 0;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`

const DefaultStepRenderer = ({index, activeStep, ...props}) => {
  const idNamespace = id("DefaultStepRenderer", props)

  return (
    <Circle id={idNamespace} isActive={index < activeStep} />
  )
}
DefaultStepRenderer.propTypes = {
  index: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired
}

export default DefaultStepRenderer
